/**
 * Created by dinesh on 13/6/17.
 */
import {Component, OnInit} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';

import {AuthorizationService} from '../../shared/authorization.service';
import {KeyValue} from '../../shared/key-value';
import { environment } from '../../../environments/environment';

declare function init_input_check(): void;

@Component({
  selector: 'sign-in',
  templateUrl: 'sign-in.component.html',
  styleUrls: ['sign-in.component.css']
})
export class SignInComponent implements OnInit {
  email: string;
  password: string;
  public errorMsg = '';
  //loader:boolean=false;
  res = '';
  showform:boolean = false;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService) {
        if(localStorage.getItem('uid')!= undefined ){
          this._tokenService.validateToken().subscribe(
            res =>      {
              console.log('....'+ JSON.stringify(res));
              localStorage.setItem('currentUserData',JSON.stringify(res));
              this.showform = false;
              authService.grantAccess();
            },
            error =>    {
              console.log(error);
              this.showform = true;
            }
          );
        } else {
          this.showform = true;
        }
      this.errorMsg =  this.authService.error_msg_agreement_rejected  //KeyValue.licence_rejected_msg;
  }


  deneyAccess(error) { console.log(error); if (error.error && error.error.errors) { this.errorMsg = error.error.errors; } else { this.errorMsg = 'An error occurred.'; } }
  ngOnInit() {
    setTimeout(function(){
      init_input_check();
    }, 1000);

    const backdrop = document.getElementsByClassName('modal-backdrop')
    if (backdrop.length !== 0 ) {
      const child = backdrop[0];
      child.parentNode.removeChild(child);
    }
  }


  submit_login(){
    this.authService.error_msg_agreement_rejected = '';
    this._tokenService.signIn({
      login: this.email,
      password: this.password
    }).subscribe(
      data => {
           this.authService.checkIfLoggedoutInDupTab();
           this.authService.grantAccess();
           if(this.authService.logoutTimerStarted === false){
            this.authService.logoutTimerStarted = true;
            this.authService.startTimer(1800000 * 10);
           }
           // Set currentUserData in localStorage after successful sign-in
           localStorage.setItem('currentUserData', JSON.stringify(data));
      },
      error => {
        this.deneyAccess(error);
      }
    );
  }

  submit(event): void {
    this.errorMsg = '';
    if (this.email != '' && this.password != '' && this.email != undefined && this.password != undefined){
      //this.loader = true;
      KeyValue.animStatus_update('start');
      let signin = this;
      setTimeout(function(){
        signin.submit_login();
        // signin.loader = false;
        KeyValue.animStatus_update('end');

      }, 500);
    }
  }

  forgotpassword(event): void {
    //event.preventDefault();
    console.log('inside forgotpassword course');
     this.router.navigate(['/forgot-password']);
  }

  revealPassword(id) {
    const element = (document.getElementById(id) as HTMLInputElement);
    if (element.type === 'password') {
      element.type = 'text';
      (document.getElementsByClassName('eye_img')[0] as HTMLInputElement).src = 'assets/images/eye.png';
    }else {
      element.type = 'password';
      (document.getElementsByClassName('eye_img')[0] as HTMLInputElement).src = 'assets/images/eye_img.png';
    }
  }
}
